<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="mb-2">
      <v-toolbar-title class="toolbar_title">
        <span
          v-if="timeTotal && timeTotal.length"
          class="title"
        >
          Selected:
          <v-chip
            dark
            color="info"
          >
            {{ timeTotal }}
          </v-chip>
        </span>
        <span v-else>Track time confirmation</span>
        <v-btn
          v-if="selected && selected.length && timeTotal"
          small
          color="info"
          @click="openLogsModal"
        >
          Get logs
        </v-btn>
        <v-btn
          v-if="selected && selected.length && timeTotal"
          small
          color="info"
          @click="openComPercentModal"
        >
          Get hours by projects
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="selected && selected.length" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="info"
            v-on="on"
          >
            Bulk actions
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in bulkActionItems"
            :key="index"
            @click="massEdit(selected, item.key, item.value)"
          >
            <v-list-tile-action>
              <v-icon :color="item.value === 'true' ? 'success' : 'error'">
                {{ item.value === 'true' ? 'check' : 'cancel'}}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              {{ item.title }}
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-card class="pa-2 mb-2">
      <v-layout row wrap>
        <v-flex xs12 sm6 md3>
          <v-menu v-model="menu" :return-value="filter.from" lazy transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                hide-details
                v-model="filter.from"
                label="From"
                v-on="on"
                outline
              />
            </template>
            <v-date-picker locale="ua-ua" :first-day-of-week="1" v-model="filter.from" no-title scrollable></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-menu v-model="menu2" :return-value="filter.to" lazy transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                hide-details
                v-model="filter.to"
                label="To"
                v-on="on"
                outline
              />
            </template>
            <v-date-picker locale="ua-ua" :first-day-of-week="1" v-model="filter.to" no-title scrollable></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-autocomplete
            v-model="filter.users"
            :items="users"
            label="Employees"
            item-text="name"
            item-value="id"
            multiple
            hide-details
            dense
            small-chips
            clearable
            outline
            @change="changeFilter"
          />
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filter.types"
            :items="timeTypes"
            label="Types"
            item-text="title"
            item-value="value"
            multiple
            hide-details
            dense
            small-chips
            clearable
            outline
            @change="changeFilter"
          />
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-autocomplete
            v-model="filter.projects"
            :items="projects"
            label="Projects"
            item-text="name"
            item-value="id"
            multiple
            hide-details
            dense
            small-chips
            clearable
            outline
            @change="changeFilter"
          />
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filterStatuses"
            :items="statuses"
            label="Status"
            item-text="title"
            item-value="key"
            multiple
            hide-details
            dense
            small-chips
            clearable
            outline
            return-object
            @change="changeFilter"
          />
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-btn
            block
            large
            color="info"
            class="ma-0"
            style="height: 100%"
            @click="doFilter"
            :loading="isLoading"
          >
            Filter
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <v-data-table
        v-model="selected"
        class="times-overview-table"
        select-all
        key="created_at"
        :headers="headers"
        :loading="isLoading"
        :pagination.sync="list.pagination"
        :total-items="list.pagination.totalItems"
        :items="list.items"
        :rows-per-page-items="[100, 200, 500, 1000]"
      >
        <template v-slot:headers="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              />
            </th>
            <th
              v-for="(header, index) in props.headers"
              :key="header.text"
              :class="index === props.headers.length - 1 ? 'text-xs-right' : 'text-xs-left'"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected">
            <td class="text-xs-left">
              <v-checkbox
                :input-value="props.selected"
                primary
                hide-details
                ma-0
                color="info"
                @change="props.selected = !props.selected"
              />
            </td>
            <td class="text-xs-left">{{ format(props.item.created_at) }}</td>
            <td class="text-xs-left">{{ props.item.user.name }}</td>
            <td class="text-xs-left">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div class="tasks_page__list--item_chip" v-on="on">
                    <router-link
                      target="_blank"
                      :to="{name: 'tasks-form', params: {project_id: props.item.task.project_id, task_id: props.item.task.id}}"
                    >
                      {{ props.item.task.short_name.toUpperCase() }}
                    </router-link>
                  </div>
                </template>
                <span>{{ props.item.task.title }}</span>
              </v-tooltip>

            </td>
            <td class="text-xs-left">{{ props.item.description }}</td>
            <td class="text-xs-left">{{ props.item.duration }}</td>
            <td class="text-xs-left">{{ getTimeTypeText(props.item.type) }}</td>
            <td class="text-xs-center">
              <div class="d-flex d-flex align-center justify-center" style="max-width: 160px;">
                <v-btn
                  v-if="props.item.approved"
                  @click="singleEdit(props.item, 'approved', false)"
                  color="error"
                  icon
                >
                  <v-icon medium>highlight_off</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  @click="singleEdit(props.item, 'approved', true)"
                  color="success"
                  icon
                >
                  <v-icon>check</v-icon>
                </v-btn>

                <v-btn
                  v-if="props.item.invoiced"
                  @click="singleEdit(props.item, 'invoiced', false)"
                  color="error"
                  icon
                >
                  <v-icon>highlight_off</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  @click="singleEdit(props.item, 'invoiced', true)"
                  color="success"
                  icon
                >
                  <v-icon>check</v-icon>
                </v-btn>

                <v-btn
                  v-if="props.item.paid"
                  @click="singleEdit(props.item, 'paid', false)"
                  color="error"
                  icon
                >
                  <v-icon>highlight_off</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  @click="singleEdit(props.item, 'paid', true)"
                  color="success"
                  icon
                >
                  <v-icon>check</v-icon>
                </v-btn>
              </div>
            </td>
            <td class="text-xs-right">
              <div class="table_actions_btns">
                <v-btn
                  icon
                  small
                  @click="openEditModal(props.item)"
                  color="info"
                  :ripple="false"
                >
                  <v-icon size="14">edit</v-icon>
                </v-btn>
                <remove-dialog :yes="() => remove(props.item)">
                  <v-btn
                    color="info"
                    class="mr-0"
                    icon
                    small
                    :ripple="false"
                  >
                    <v-icon size="14">delete_forever</v-icon>
                  </v-btn>
                </remove-dialog>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <edit-modal
      ref="edit"
      :time="currentTime"
      @edit="refresh"
    />
    <format-dialog
      ref="logs"
      :times="selected"
      :total="timeTotal"
    />
    <com-percent-dialog
      ref="comPercent"
      :list="selected"
    />
  </v-container>
</template>

<script>
  import moment from 'moment'
  import * as mixins from '@/mixins/'
  import edit from '@/components/times/edit'
  import FormatDialog from "../../components/times/format-dialog";
  import timeTypes from "@/entities/timeTypes";
  import timeStatuses from "@/entities/timeStatuses";
  import ComPercentDialog from "@/components/times/com-percent-dialog.vue";

  export default {
    name: 'TimesListPage',
    mixins: [mixins.removable, mixins.timesPageList, mixins.filter, mixins.preloader],
    data() {
      return {
        api: this.$api.times,
        currentTime: {},
        menu: false,
        menu2: false,
        selectedCheckbox: [],
        timeTypes: timeTypes,
        selected: [],
        projects: [],
        users: [],
        filter: {
          users: [],
          projects: [],
          from: '',
          to: '',
        },
        filterStatuses: [],
        statusesList: timeStatuses,
        list: {
          pagination: {
            rowsPerPage: 100,
          }
        },
        headers: [
          {text: 'Date', align: 'left', sortable: false, value: 'created_at', width: "150px"},
          {text: 'Employee', align: 'left', sortable: false, width: "180"},
          {text: 'Task', align: 'left', sortable: false},
          {text: 'Track description', align: 'left', sortable: false},
          {text: 'Time', align: 'left', sortable: false, width: "100"},
          {text: 'Type', align: 'left', sortable: false, value: 'created_at'},
          {text: 'Approved/Invoiced/Paid', align: 'left', sortable: false},
          {text: 'Action', align: 'right', sortable: false},
        ],
        bulkActionItems: [
          {
            title: 'Approved',
            key: 'approved',
            value: 'true'
          },
          {
            title: 'Invoiced',
            key: 'invoiced',
            value: 'true'
          },
          {
            title: 'Paid',
            key: 'paid',
            value: 'true'
          },
          {
            title: 'Not approved',
            key: 'approved',
            value: 'false'
          },
          {
            title: 'Not invoiced',
            key: 'invoiced',
            value: 'false'
          },
          {
            title: 'Not paid',
            key: 'paid',
            value: 'false'
          },
        ],
      }
    },
    computed: {
      timeTotal() {
        const totalTime = this.selected.reduce((acc, item) => acc + item.minutes, 0);

        return `${parseInt(totalTime / 60)}h ${totalTime % 60}m`;
      },
      statuses() {
        return this.statusesList
          .filter(item => {
            // Check if item is in filterStatuses based on original_key
            const originalKeyMatch = this.filterStatuses.some(selectedItem => selectedItem.original_key === item.original_key)
            // Check if item is in filterStatuses based on key
            const keyMatch = this.filterStatuses.some(selectedItem => selectedItem.key === item.key)

            return !originalKeyMatch || keyMatch
          })
      }
    },
    methods: {
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.list.items.slice()
      },
      loadProjects() {
        return this.$api.projects.list({ unlimit: 1 }).then(({ data }) => {
          this.projects = data
        })
      },
      loadUsers() {
        return this.$api.users.list({ unlimit: 1 }).then(response => {
          this.users = response.data.data ? response.data.data : response.data
        })
      },
      format(date) {
        return moment(date).format("DD.MM.YYYY HH:mm")
      },
      collectSort(params) {
        return {
          ...params,
          order: 'id',
          direction: 'desc'
        }
      },
      openEditModal(time) {
        this.currentTime = time
        this.$refs.edit.open()
      },
      refresh() {
        this.load()
      },
      massEdit(array, field, value) {
        let data = {
          times: array.map((item) => item.id),
          field: field,
          value: value
        }
        this.$api.times.massiveSave(data).then(() => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Value changed'
          })
          this.refresh()
        })
      },
      singleEdit(item, field, value) {
        item[field] = value
        this.$api.times.save(item).then(() => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Value changed'
          })
          this.refresh()
        })
      },
      openLogsModal() {
        this.$refs.logs.open()
      },
      openComPercentModal() {
        this.$refs.comPercent.open()
      },
      changeFilter() {
        this.selected = this.selected.splice()
      },
      doFilter() {
        // check if filter by status has active items
        if (this.filterStatuses.length > 0) {
          this.filterStatuses.forEach(status => {
            this.filter[status.original_key] = status.value
          })
        } else {
          // additionally clear statuses filter items in the filter object if no items selected
          this.statusesList.forEach(status => {
            this.filter[status.original_key] = null
          })
        }

        this.load()
      },
      async getCurrentSprintByDate(date = '') {
        return this.$api.reports.getSprintDates({ from: date, unlimit: 1 }).then(response => {
          this.filter.from = response.data.from
          this.filter.to = response.data.to
        }, (error) => {
          // eslint-disable-next-line no-console
          console.error(error)
        })
      },
      getTimeTypeText(type) {
        if (type) {
          const existedType = this.timeTypes.find(item => item.value === type)
          return existedType ? existedType.title : 'no type'
        }

        return 'no type'
      }
    },
    async mounted() {
      let preload = [this.loadProjects(), this.loadUsers()]
      preload.forEach(item => this.background(item))

      await this.getCurrentSprintByDate()
      this.load()
    },
    components: {
      ComPercentDialog,
      FormatDialog,
      'edit-modal': edit
    }
  }
</script>

<style lang="stylus">
.times-overview-table
  th, td
    padding 0 5px !important
</style>